import { Injectable } from "@angular/core";
import { ThemeService } from "../../themes/theme.service";
import { Title } from "@angular/platform-browser";
import { CUSTOM_URLS } from "../../screens/login/CUSTOM_URLS";

/** Applies title, favicon, and theme overrides from the first matching CUSTOM_URLS entry. */
@Injectable({
  providedIn: "root",
})
export class CustomUrlService {
  constructor(
    private readonly theme: ThemeService,
    private readonly titleService: Title,
  ) {}

  checkCustomUrl(): void {
    let customUrl = CUSTOM_URLS.find((url: any) =>
      window.location.href.includes(url.urlText),
    );
    if (customUrl?.appTitle) {
      this.titleService.setTitle(customUrl.appTitle);
    }
    if (customUrl?.appIcon) {
      document
        .getElementById("appFavicon")
        .setAttribute("href", customUrl.appIcon);
    }
    if (customUrl?.theme) {
      this.theme.setTheme(customUrl?.theme);
    }
  }
}
